module.exports = __webpack_public_path__ + "img/020.67dd7e15.png";